import { BrowserRouter as Router, Route, Routes, NavLink, useLocation } from 'react-router-dom';
import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import './App.css';

import 'slick-carousel';
import Slider from "react-slick";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ScrollToTop from './pages/ScrollToTop';
import Home from './pages/Home';
import CryptoFearGreedIndex from './pages/CryptoFearGreedIndex';
import LiquidationHeatmap from './pages/LiquidationHeatmap';
import BitcoinDominance from './pages/BitcoinDominance';
import CoinList from './pages/CoinList';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/BlogDetails';
import ArticalDetails from './pages/ArticalDetails';
import News from './pages/News';
import CoinDetails from './pages/CoinDetails';
import Price from './pages/Price';
import TermsService from './pages/TermsService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactSupport from './pages/ContactSupport';
import FAQ from './pages/FAQ';
import Compliance from './pages/Compliance';
import RiskDisclosure from './pages/RiskDisclosure';
import SearchBox from './pages/SearchBox';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

function App() {
	const [topCoins, setTopCoins] = useState([]);
	const [showPopup, setShowPopup] = useState(false);
	const [isSticky, setIsSticky] = useState(false);
	const [loading, setLoading] = useState(true);
	const fetchData = async () => {
    try {
      const response = await fetch(`${apiUrl}/get-topcoins-data`);
      const data = await response.json();
      setTopCoins(data);  
      setLoading(false);   
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {   // adjust 50px as per your need
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const Navbar = () => {
	  const location = useLocation();

	  return (

	  	<ul className="navbar-nav">
				<li className="nav-item">
					<NavLink className={location.pathname === '/' ? 'nav-link active' : 'nav-link'} to={`${homeUrl}`}>Home</NavLink>
				</li>
				<li className="nav-item">
					<NavLink className={location.pathname === '/price' ? 'nav-link active' : 'nav-link'} to={`${homeUrl}price`}>Premium</NavLink>
				</li>
				<li className="nav-item">
					<NavLink className={location.pathname === '/news' ? 'nav-link active' : 'nav-link'} to={`${homeUrl}news`}>Crypto News</NavLink>
				</li>
				<li className="nav-item">
					<NavLink className={location.pathname === '/blogs' ? 'nav-link active' : 'nav-link'} to={`${homeUrl}blogs`}>Crypto Blogs</NavLink>
				</li>
			</ul>
	  );
	};

  return (
	<Router>
		<>
		<ScrollToTop />
		<div className="App">
			<div className="price_ticker">
				<div className="container-fluid">
					<div className="price_ticker_slider animate-ticker">
						{topCoins.length > 0 && topCoins.map((coin) => (
						<div className="pricetickerbox" key={coin.id}>
							<div className="boxsec">
								<span className="coinname">{coin.symbol.toUpperCase()}</span>
								
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right h-3 w-3 mx-2 text-gray-500"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
								
								<span className="pricetxt">${coin.current_price < 1 
                          ? coin.current_price.toFixed(6) 
                          : coin.current_price.toFixed(2)}</span>
								
								<span className={`updown_price ${coin.price_change_percentage_24h >= 0 ? 'upprice' : 'downprice'}`}>
                  {coin.price_change_percentage_24h >= 0 ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up h-3 w-3 mr-1">
                      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                      <polyline points="16 7 22 7 22 13"></polyline>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-down h-3 w-3 mr-1">
                      <polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>
                      <polyline points="16 17 22 17 22 11"></polyline>
                    </svg>
                  )}
                  {Math.abs(coin.price_change_percentage_24h).toFixed(1)}%
                </span>
							</div>
						</div>
						))}
					</div>
				</div>
			</div>
			
			<header className={`header_mainsec ${isSticky ? "sticky" : ""}`}>
				<nav className="navbar navbar-expand-lg">
					<div className="container">
						<a className="navbar-brand" href="/">
							{/*<img className="blacklogo" src={`${homeUrl}/assets/img/text-logo01.png`} />*/}
							<h2>coinviews</h2>
						</a>
						
						<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						
						<div className="collapse navbar-collapse" id="navbarSupportedContent">
							<Navbar />
						</div>
						
						<div className="rightbox">
							{/*<div className="notificationbox">
								<button>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-bell h-5 w-5"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path></svg>
									<div className="notificationdot"></div>
								</button>
							</div>*/}
							
							<div className="searchbox">
								<button onFocus={() => setShowPopup(true)}>
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-search h-5 w-5"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
								</button>
								{showPopup && (
							    <SearchBox onClose={() => setShowPopup(false)} />
							  )}
							</div>
							
							{/*<div className="loginbox">
								<button className="loginbtn">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-user h-4 w-4"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
									<span>Login</span>
								</button>
							</div>*/}
						</div>
					</div>
				</nav>
			</header>
			
			<Routes>      
				<Route exact path="/" element={<Home />} />
				<Route exact path="/coin-list" element={<CoinList />} />
				<Route exact path="/blogs" element={<Blogs />} />
				<Route exact path="/blog/:blog_slug" element={<BlogDetails />} />
				<Route exact path="/artical/:artical_slug" element={<ArticalDetails />} />
				<Route exact path="/news" element={<News />} />
				<Route exact path="/price" element={<Price />} />
				<Route exact path="/terms-of-service" element={<TermsService />} />
				<Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route exact path="/contact-support" element={<ContactSupport />} />
				<Route exact path="/frequently-asked-questions" element={<FAQ />} />
				<Route exact path="/compliance" element={<Compliance />} />
				<Route exact path="/risk-disclosure" element={<RiskDisclosure />} />
				<Route path="/coin/:coin_slug" element={<CoinDetails />} />
			</Routes>
			
			<footer>
				<div className="footer_mainsec">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<div className="about_contnt">
									<div className="logobox">
										<h2>coinviews</h2>
									</div>
									
									<div className="contntbox">
										<p>Real-time market insights, crypto news, trading signals, and step-by-step guides to help traders and investors stay ahead. Backed by expert analysis and a growing global community, we make crypto trading smarter, faster, and easier. Join us on Telegram for your daily market edge.</p>
									</div>
									
									<div className="social_media">
										<ul>
											<li><a href="https://x.com/coinviewsIO" target="_blank"><i className="fa-brands fa-x-twitter"></i></a></li>
											<li><a href="https://www.linkedin.com/company/coinviews/" target="_blank"><i className="fa-brands fa-linkedin-in"></i></a></li>
											<li><a href="https://t.me/coinviews144" target="_blank"><i className="fab fa-telegram-plane"></i></a></li>
											<li><a href="https://www.instagram.com/coinviewsio/" target="_blank"><i className="fab fa-instagram"></i></a></li>
										</ul>
									</div>
								</div>
							</div>
							
							<div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<div className="menu_mainsec">
									<div className="title_box">
										<h3>Trading</h3>
									</div>
									
									<div className="menu_box">
										<ul>
											<li><a href={`${homeUrl}coin-list`}>Price Tracker</a></li>
											<li><a href={`${homeUrl}news`}>Crypto News</a></li>
										</ul>
									</div>
								</div>
							</div>
							
							<div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<div className="menu_mainsec">
									<div className="title_box">
										<h3>Support</h3>
									</div>
									
									<div className="menu_box">
										<ul>
											<li><a href={`${homeUrl}contact-support`}>Contact Support</a></li>
											<li><a href="#">Trading Guide</a></li>
											<li><a href={`${homeUrl}frequently-asked-questions`}>FAQ</a></li>
										</ul>
									</div>
								</div>
							</div>
							
							<div className="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<div className="menu_mainsec">
									<div className="title_box">
										<h3>Legal</h3>
									</div>
									
									<div className="menu_box">
										<ul>
											<li><a href={`${homeUrl}terms-of-service`}>Terms of Service</a></li>
											<li><a href={`${homeUrl}privacy-policy`}>Privacy Policy</a></li>
											<li><a href={`${homeUrl}risk-disclosure`}>Risk Disclosure</a></li>
											<li><a href={`${homeUrl}compliance`}>Compliance</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div className="copyright_mainsec">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<div className="copyright_sec">
									<p>© 2025 Coinviews. All Rights Reserved.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
				{loading && (
				<div className="loader_mainbox">
					<div className="loader_mainsec">
						<div className="loader market-spinner">
							<svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-label="Loading market data">
							<polyline points="22 7 13.5 15.5 8.5 10.5 2 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<polyline points="16 7 22 7 22 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>
							 
						<div className="text-loader">
							<span>C</span>
							<span>O</span>
							<span>I</span>
							<span>N</span>
							<span>V</span>
							<span>I</span>
							<span>E</span>
							<span>W</span>
							<span>S</span>
						</div>
					</div>
				</div>
			)}
		</div>
		</>
	</Router>
  );
}

export default App;
